export default {
    SpaceBar: 32,
    Enter: 13,
    ArrowLeft: 37,
    ArrowUp: 38,
    ArrowRight: 39,
    ArrowDown: 40,
    PageUp: 33,
    PageDown: 34,
    Home: 36,
    End: 35,
    Tab: 9,
};